export default () => {
  const { $t } = useNuxtApp()

  const checkIsCont = [
    { value: 'true', label: $t('labels.cont') },
    { value: 'false', label: $t('labels.notCont') }
  ]

  const transportation = [
    { value: 'CONTAINER', label: $t('labels.containerTruck') },
    { value: 'NON_CONTAINER', label: $t('labels.nonContainerTruck') }
  ]

  return {
    checkIsCont,
    transportation
  }
}
